import React from 'react';
import { MdOutlineErrorOutline } from 'react-icons/md';

function NoPenalties() {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <MdOutlineErrorOutline className="text-6xl text-gray-400" />
      <p className="mt-4 text-lg text-gray-600">No penalties found.</p>
      <p className="text-sm text-gray-500">You have no penalty records at the moment.</p>
    </div>
  );
}

export default NoPenalties;
